import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CodeSandboxOutlinedSvg from "@ant-design/icons-svg/es/asn/CodeSandboxOutlined";
import AntdIcon from "../components/AntdIcon";
var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeSandboxOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
}
export default /*#__PURE__*/React.forwardRef(CodeSandboxOutlined);